import type {GetSelectionReportResponse} from '../../../core/repositories/reportsRepository';

export type ListSelectionReportBaseInfo = Array<{
  label: string;
  value: string;
}>;

export const listSelectionReportBaseInfo = (
  selectionReport: GetSelectionReportResponse,
): ListSelectionReportBaseInfo => {
  return [
    {
      label: '社名',
      value: selectionReport.company.name,
    },
    ...(selectionReport.department.id > 0
      ? [
          {
            label: '部門(職種)',
            value: selectionReport.department.name,
          },
        ]
      : []),
    ...(selectionReport.eventName === ''
      ? []
      : [
          {
            label: 'イベント名',
            value: selectionReport.eventName,
          },
        ]),
    ...(selectionReport.sectionList[0]
      ? selectionReport.sectionList[0].questionAnswerList
      : []
    ).map((qa) => {
      return {
        label: qa.question,
        value: qa.answer,
      };
    }),
  ];
};
